module.exports = __webpack_public_path__ + "static/banner-revistas-largo-cf923de7d43be2435c15acf69a8c6d72.jpg";